import { useToast } from 'vue-toastification';
import { ClientError } from 'nice-grpc-web';
import extractErrorMessage from '@/utils/handle-error';

export default function useServiceErrorHandler(): (error: ClientError) => void {
  const toast = useToast();

  return (error: ClientError) => {
    toast.error(extractErrorMessage(error));
  };
}
